/** Stored default banner path on the API (see CommonConfig.DEFAULT_USER_BANNER_IMAGE). */
const DEFAULT_BANNER_STORED_SUFFIX = '/defaults/upload-banner.png';

/** Default profile banner served from CRA `public/upload-banner.png`. */
export function defaultProfileBannerUrl(): string {
  const publicPath = String(process.env.PUBLIC_URL || '').replace(/\/$/, '');
  return `${publicPath}/upload-banner.png`;
}

/** True when the API value is the built-in default banner (not a user upload). */
export function isDefaultProfileBannerPath(value?: string | null): boolean {
  const raw = String(value ?? '').trim();
  if (!raw) return true;

  const normalized = raw.includes('://')
    ? (() => {
        try {
          return new URL(raw).pathname;
        } catch {
          return raw;
        }
      })()
    : raw;

  return (
    normalized.endsWith(DEFAULT_BANNER_STORED_SUFFIX) ||
    normalized === 'defaults/upload-banner.png' ||
    normalized.endsWith('images/defaults/upload-banner.png')
  );
}

/**
 * Use API banner for custom uploads; map the API default path to the front public asset
 * so it works even when the API host does not serve `/images/defaults/upload-banner.png`.
 */
export function resolveProfileBannerUrl(apiBanner?: string | null): string {
  const raw = String(apiBanner ?? '').trim();
  if (!raw || isDefaultProfileBannerPath(raw)) {
    return defaultProfileBannerUrl();
  }
  return raw;
}
